import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import Store from 'store/store';
import { findInVNode } from 'utils/vnode';
// import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {

	constructor(props) {
		super(props);
		this.onKeyDown = this.onKeyDown.bind(this);
	}

	componentDidMount() {
		super.componentDidMount();
		document.addEventListener('keydown', this.onKeyDown);
	}

	componentWillUnmount() {
		super.componentWillUnmount();
		document.removeEventListener('keydown', this.onKeyDown);
	}

	onKeyDown(e) {
		if (e.key === 'Escape' && this.props.headerData?.open) {
			Store.emit('CLOSE_NAV_MENU');
		}
	}

	render(props, state) {
		const base = super.render(props, state);
		const headerContainer = findInVNode(base, '#header');

		if (headerContainer) {
			headerContainer.nodeName = 'header';
		}

		return base;
	}

	renderExtraActions() {
		const base = super.renderExtraActions();
		if (base && this.props.headerData?.open) {
			base.attributes.inert = true;
			base.attributes['aria-hidden'] = 'true';
		}
		return base;
	}

	renderPersistentButton() {
		const base = super.renderPersistentButton();
		if (base && this.props.headerData?.open) {
			base.attributes.inert = true;
			base.attributes.tabIndex = -1;
			base.attributes['aria-hidden'] = 'true';
		}
		return base;
	}

	renderShare() {
		return;
	}

}
